import React from 'react';
import './Stats.css';

const stats = [
  { label: 'GPUs', value: '40+' },
  { label: 'Users', value: '200+' },
  { label: 'API Calls', value: '20,000+' }
];

const Stats = () => (
  <section className="section stats">
    <div className="container stats-grid">
      {stats.map((s) => (
        <div key={s.label} className="stat-card">
          <div className="stat-value">{s.value}</div>
          <div className="stat-label">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default Stats;
